import { createFileRoute } from "@tanstack/react-router";
import { FeedbackInboxPage } from "../features/feedback/pages/inbox-page";

/** Reports from roasteries (EP-53, US-53.5). */
export const Route = createFileRoute("/feedback/")({
  component: FeedbackInboxPage,
});
